// extracted by mini-css-extract-plugin
export default {"Container":"ChargePointTabSkeleton_Container__WFZsn"};